import { useMemo } from 'react';
import { Api } from '@sib/api';
import { env } from '@sib/config';

export const useAgentApi = (aiPort?: string | null): Api<unknown> =>
  useMemo(() => {
    const baseURL = `${env.agentApiBaseUrl}${aiPort ? `:${aiPort}` : ''}`;

    return new Api({ baseURL });
  }, [aiPort]);
